
  <script>
  import Layout from "../../layouts/main";
  import appConfig from "@/app.config";
  import ItemsApi from "@/services/items-api";
  import simplebar from "simplebar-vue";
  
  export default {
    page: {
      title: "Catalogue",
      meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout,  simplebar },
    props: {
      categoryId: { type: Number, default: null }
    },

    watch: {
    '$route': {
      immediate: true,
      deep: true,
      handler(route) {
        const rawSection = route.params.sectionName;
        this.selectedSectionNames = rawSection
          ? decodeURIComponent(rawSection).split(',').filter(Boolean)
          : [];
      }
    }
  },

    computed: {
    isMobile() {
      return window.innerWidth < 768;
    },
    },
    mounted() {
      this.getAllSection()
      this.findItems()
      

    },
    data() {
      return {
        openFilter: this.isMobile ? false :true  ,
        selectedSectionNames:[],

        itemsList:[],
        showItemsSpinner:false,
        pagemodel: {currentPage : 1, perPage :12, totalRows: 0},
        reference: null,
        categories: null,

        itemsListTimestamp:null,
        selectedPaperType:null,
        

      };
    },
    methods: {

      handleRouteChange(route) {
        const rawSection = route.params.sectionName;
        this.selectedSectionNames = rawSection
          ? decodeURIComponent(rawSection).split(',').filter(Boolean)
          : [];

        this.findItems();
      },
      getQueryParamValues(paramName) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const values = urlSearchParams.get(paramName)
          ? urlSearchParams.get(paramName).split(',').filter(Boolean)
          : [];
        return values;
      },

      toggleQueryParamArray(selectedList, paramName, value , isRemove) {

        const { pathname, origin, search } = window.location;
        const urlSearchParams = new URLSearchParams(search);

        let values = urlSearchParams.get(paramName)
          ? urlSearchParams.get(paramName).split(',').filter(Boolean)
          : [];

        if (values.includes(value) || isRemove) {
            values = values.filter(v => v !== value);
        } else {
          values.push(value);
        }

        selectedList.splice(0, selectedList.length, ...values);

        if (values.length) {
          urlSearchParams.set(paramName, values.join(','));
        } else {
          urlSearchParams.delete(paramName);
        }

        const queryString = Array.from(urlSearchParams.entries())
          .map(([key, val]) => `${key}=${val}`)
          .join('&');

        const newUrl = `${origin}${pathname}${queryString ? '?' + queryString : ''}`;
        history.pushState(null, '', newUrl);

        this.findItems();

      },

      loadMoreItems() {
          this.pagemodel.currentPage++;
          this.findItems(true);
      },

    

      selecteCategorie(category) {
        const { pathname, origin, search } = window.location;
        const segments = pathname.split('/').filter(Boolean);

        if (segments[0] !== 'sac-personnalise') return;

        let categories = segments[1] ? segments[1].split(',').map(decodeURIComponent) : [];

        const seoName = category.seoName;

        if (categories.includes(seoName)) {
          categories = categories.filter(c => c !== seoName);
        } else {
          categories.push(seoName);
        }

        this.selectedSectionNames = categories;

        let newPath = '/sac-personnalise';
        if (categories.length) {
          newPath += '/' + categories.map(encodeURIComponent).join(',');
        }

        const queryParams = new URLSearchParams(search);
        const rawQuery = queryParams.toString().replace(/%2C/g, ',');

        const newUrl = origin + newPath + (rawQuery ? '?' + rawQuery : '');
        history.pushState(null, '', newUrl);

        this.findItems();
      },


    getAllSection(){
      ItemsApi.getAllSection().then(
          result =>{
              this.categories = result 
          }
      )
    },

    setVisitItem(selectedItemId){
      const isCatalogScreen = 0
      ItemsApi.setVisitItem(selectedItemId ,isCatalogScreen)
    },

      
    findItems(isLoadMoreItem) {

      if(!isLoadMoreItem){
        this.pagemodel.currentPage = 1;
      }

    this.showItemsSpinner = true;
      this.itemsListTimestamp = new Date().getTime();

      ItemsApi.findItems(this.pagemodel.currentPage, this.pagemodel.perPage,true, this.reference, this.selectedSectionNames.join(','),this.selectedPaperType ,this.itemsListTimestamp).then(itemsList => {
            
        if(itemsList){

          if (itemsList.requestTimestamp && itemsList.requestTimestamp != this.itemsListTimestamp) {
            return;
          }

          if(isLoadMoreItem){
            this.itemsList.push(...itemsList.list)
          }else{
            this.itemsList = itemsList.list
          }

          this.pagemodel.totalRows = itemsList.total;
          this.pagemodel.currentPage = itemsList.page;
          this.pagemodel.perPage = itemsList.pageSize;
          this.pagemodel.pageSize = itemsList.pageSize;
          this.pagemodel.maxPagesCount = itemsList.maxPagesCount;
                
          } else {

            this.itemsList = []
            this.pagemodel.totalRows = 0;
            this.pagemodel.currentPage = 1;
            this.pagemodel.maxPagesCount = 0;
          }
        })
          .finally(() => {
              this.showItemsSpinner = false;
          })
      },

      toggleFilter() {
        this.openFilter = !this.openFilter; 
      },

      removeCategory(seoName) {
        this.selectedSectionNames = this.selectedSectionNames.filter(name => name !== seoName);
      },


      removeColor(color) {
        this.colorRemoveQueryParam(color)
      },

      selectPaperType(paperType){
        if(this.selectedPaperType === paperType ){
          this.selectedPaperType = null;
        }else{
          this.selectedPaperType = paperType;
        }
        this.findItems();
      },
    }
  };
  </script>

<template>
  <Layout>
    <div class="home-page-80-width mt-2 mt-lg-5">
      <div class="row mb-5 pb-5">
        <div class=" buttonRow pt-4 pb-3">
          <div class="row  col-12 filter d-flex align-items-center mt-2 mb-2" :class="openFilter ? 'filter-when-open' : ''">

            <div class="col-lg-2 col-12">
              <div>
                <!-- Desktop View -->
                <div class="d-none d-lg-flex align-items-center">
                  <img class="iconsettings" alt="Settings" src="@/assets/images/Settings.png" />
                  <span class="ml-2">Filtrer</span>
                </div>

                <!-- Mobile View -->
                <div
                  @click="toggleFilter"
                  class="d-flex d-lg-none align-items-center getStarted col-12"
                  style="cursor: pointer;"
                >
                  <img
                    class="iconsettings"
                    alt="Toggle"
                    :src="openFilter ? require('@/assets/icons/arrow-right.svg') : require('@/assets/icons/arrow-left.svg')"
                    style="padding-bottom: 4px;"
                  />
                  <span class="font-size-20 mx-2">Filtrer</span>
                  <img class="iconsettings" alt="Settings" src="@/assets/images/Settings.png" />
                </div>
              </div>
            </div>

            <div class="col-lg-10 col-12 ">
              
              <span v-if="selectedSectionNames && selectedSectionNames.length">
                <span
                  v-for="seoName in selectedSectionNames"
                  :key="'cat-' + seoName"
                  class="badge badge-primary text-secondary text-uppercase mr-2 mb-lg-0 mb-2"
                  @click="removeCategory(seoName)"
                  style="cursor: pointer;   font-family: Tahoma, Geneva, Verdana, sans-serif !important;"
                >
                  <span v-if="categories" >{{ (categories.find(cat => cat.seoName === seoName) || {}).name || '' }}</span>
                  <span @click="removeCategory(seoName)" style="cursor: pointer; padding-left: 6px;">×</span>
                </span>
              </span>
              <span v-if="selectedPaperType != null" class="badge badge-primary text-secondary text-uppercase mr-2 mb-lg-0 mb-2"
                @click="selectPaperType(null)" style="cursor: pointer;  font-family: Tahoma, Geneva, Verdana, sans-serif !important;" >
                {{ selectedPaperType === 0 ? 'Sac Papier Kraft' : 'Sac Papier Ingraissable' }}
                <span  style="cursor: pointer;padding-left: 6px;"> ×</span></span>              
            </div>
          </div>
        </div>

        <simplebar class=" simplebar">
            <div :class="{'filter-panel filter-full-screen': openFilter,'col-12 col-lg-3 filter-panel': !openFilter}">
                <!-- Categories -->
                <h5 class="mt-3 mb-3 text-uppercase font-weight-bold text-dark text-left pb-2" style="letter-spacing: 2px; border-bottom: 1px solid #ddd;">Univers</h5>
                <b-form-group>
                  <div v-for="(category, index) in categories" :key="index" class="d-flex align-items-center mt-2" >
                    <b-form-checkbox
                      :id="'category-' + category.id"
                      :checked="selectedSectionNames.includes(category.seoName)"
                      class="custom-checkbox custom-checkbox-primary"
                      @input="selecteCategorie(category)"
                    >
                    </b-form-checkbox>
                    <label class="ml-1 mb-0 text-dark font-size-18"
                      :for="'category-' + category.id"
                      style="cursor: pointer"
                    >
                      {{ category.name }}
                    </label>
                    </div>
                </b-form-group>

                <h5 class="mt-5 mb-3 text-uppercase font-weight-bold text-dark text-left pb-2" 
                    style="letter-spacing: 2px; border-bottom: 1px solid #ddd;">Type de papier</h5>

                <div class="d-flex align-items-center mt-2">
                  <b-form-checkbox class="custom-checkbox custom-checkbox-primary d-flex align-items-center"
                    :checked="selectedPaperType!=null && selectedPaperType === 0"
                    @change="selectPaperType(0)">
                    <span class="ml-2 text-dark font-size-18">Sac Papier Kraft</span>
                  </b-form-checkbox>
                </div>

                <div class="d-flex align-items-center mt-2">
                  <b-form-checkbox class="custom-checkbox custom-checkbox-primary d-flex align-items-center"
                    :checked="selectedPaperType!=null && selectedPaperType === 1"
                    @change="selectPaperType(1)">
                    <span class="ml-2 text-dark font-size-18">Sac Papier Ingraissable</span>
                  </b-form-checkbox>
                </div>
          </div>
      </simplebar>
          <!-- AFFICHAGE DES PRODUITS -->
          <div  :class="{ 'col-12 col-lg-9 pl-lg-3 pt-4': true, 'd-none': !openFilter }" >
            <div class="row">
              <div class="row d-flex align-items-stretch  h-100 w-100 modelContainer">
                <div v-for="(model, index) in itemsList"  :key="index"
                    class="col-12 col-sm-4 col-xl-3  mb-4 d-flex justify-content-center mx-0 p-3" >
                  <router-link :to="{ path: '/sac-personnalise' + model.url }" @click.native="setVisitItem(model.id)">
                    <div class="catalogue-image" style="overflow: hidden;">
                      <img v-bind:src="'/api/image/get/' + model.mainImage" alt  >
                    </div>
                    <div class="mt-2 item-info text-dark">
                      <div class="font-size-16 mt-4 pl-2 font-size-18 typeName"> {{ model.title }}</div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <p v-if="itemsList.length === 0" class="text-center text-muted">Aucun modèle trouvé.</p>

            <div v-if="!this.showItemsSpinner && this.pagemodel.maxPagesCount != this.pagemodel.currentPage && this.pagemodel.totalRows != 0" class="showMore mb-2">
              <div class="showMoreButton text-dark" @click="loadMoreItems()">
                Afficher plus de modèles
              </div>
            </div>
          </div>





        </div>



      </div>
    </Layout>
  </template>
  
  <style scoped>

.showMore {
  display: flex;
  justify-content: center;
  width: 100%;
  text-align: right;
  font-size: 14px;
  color: #000;
}

.showMoreButton {
  letter-spacing: 1.1px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.showMoreButton:hover {
  background-color: #eee; /* Optional: hover effect */
}


.badge{
  margin-top: 3px ;
  margin-bottom: 3px ;
}

.simplebar{
  max-height: 90vh;
  width: 300px;
}
  
.filter-panel {
  transition: transform 0.3s ease-in-out; 
  z-index: 1000;
  /* width: 300px; */
}

.filter-panel::-webkit-scrollbar {
  width: 3px;
}

.filter-panel::-webkit-scrollbar-button {
  display: none;
}

.filter-panel::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
  border: 2px solid #f1f1f1;
}

.filter-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}




  .filters-panel h5 {
    font-weight: bold;
  }

@media (max-width: 992px) {
  .filter-full-screen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: translateX(-100%); 
    box-sizing: border-box;
    padding: 20px;
  }

  .filter-full-screen[v-show="true"] {
    transform: translateX(0); 
  }

  .modelContainer {
    display: none;
  }
}

/* Desktop: Static Sidebar */
@media (min-width: 993px) {
  .filter-panel {
    position: static;
    transform: translateX(0);
    border-radius: 5px;
    padding: 20px;
  }
}

.modelContainer {
  z-index: 1; 
}

.catalogue-image {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #ddd;
  transition: transform 0.3s ease-in-out;
  z-index: 1;
}

.catalogue-image img {
  /* width: 240px;
  height: 200px; */
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px;
  object-fit: cover;
  transition: transform 1s ease;
}
@media (min-width: 576px) and (max-width: 767px)  {
  .catalogue-image img {
    width: 240px;
    height: 240px;
  }
  .catalogue-image  {
    width: 240px;
    height: 220px;
  }
}
@media (min-width: 768px) and (max-width: 992px)  {
  .catalogue-image img {
    width: 220px;
    height: 220px;
  }
  .catalogue-image  {
    width: 220px;
    height: 220px;
  }
}
@media (max-width: 576px)  {
  .catalogue-image img {
    width: 290px;
    height: 220px;
  }
}

.catalogue-image:hover img {
  transform: scale(1.1);
}

.catalogue-image.selected {
  border: 2px solid #012b95;
  box-shadow: 0 0 10px #012b9591;
  transform: scale(1.02);
}

.getStarted {
  position: relative;
  letter-spacing: -0.4px;
  line-height: 28px;
  font-weight: 500;
}

.filter {
  text-align: left;
  font-size: 16px;
  color: #121212;
  font-family: Poppins;
  padding-left: 1.5%;
}

@media (max-width: 991px) {
  .filter-when-open {
    display: inline;
  }
}

.iconsettings {
  position: relative;
  width: 20px;
  height: 20px;
  overflow: hidden;
  flex-shrink: 0;
}

.buttonRow {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 16px;
  color: #121212;
  /*font-family: Poppins;*/
  padding-left: 1%;
  padding-right: 1%;
}

.badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 0.25rem;
  border: 0.8px solid #dcdcdc;
  font-size: 14px;
  transition: background-color 0.2s;
}

.badge-primary {
  background-color: #f5f5f5;;
  color: black;
}

.badge:hover {
  background-color: #dcdcdc;;
}


  </style>
  